<template>
  <div class="appointment">
    <div class="avt">
      <img src="../assets/logo.png" class="avt-image" />
      <div class="avt-text">
        <div style="font-size: 0.19rem; letter-spacing: 1px">
          青浦文旅健康状况信息登记
        </div>
      </div>
    </div>
    <div class="appointment-content">
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
        label-position="top"
      >
        <el-form-item label="1.您的姓名" prop="name">
          <el-input v-model="ruleForm.name"></el-input>
        </el-form-item>
        <el-form-item label="2.身份证/护照" prop="idcard">
          <el-radio-group v-model="cardType" class="cardType">
            <el-radio label="身份证"></el-radio>
            <el-radio label="护照"></el-radio>
          </el-radio-group>
          <el-input v-model="ruleForm.idcard"></el-input>
        </el-form-item>
        <el-form-item label="3.联系方式" prop="phone">
          <el-input v-model="ruleForm.phone"></el-input>
        </el-form-item>
        <!-- <el-form-item label="4.在沪居住地址" prop="address">
          <el-input v-model="ruleForm.address"></el-input>
        </el-form-item> -->
        <!-- <el-form-item label="5.是否自中高风险地区出发" prop="leaveType">
          <el-radio-group v-model="ruleForm.leaveType">
            <el-radio label="否">否</el-radio>
            <el-radio label="高风险地区">高风险地区</el-radio>
            <el-radio label="中风险地区">中风险地区</el-radio>
            <el-radio label="其他地区">其他地区</el-radio>
            <el-form-item
              label="离开日期"
              prop="leaveTime"
              v-if="ruleForm.leaveType != '否'"
            >
              <el-date-picker
                v-model="ruleForm.leaveTime"
                value-format="yyyy-MM-dd"
                format="yyyy-MM-dd"
                type="date"
              >
              </el-date-picker>
            </el-form-item>
          </el-radio-group>
        </el-form-item> -->
        <el-form-item label="4.近三日内途径地" prop="trip">
          <div
            v-for="(item, index) in ruleForm.trip"
            :key="index"
            style="
              border: 1px solid #ccc;
              margin-bottom: 0.1rem;
              padding: 0.1rem;
              box-sizing: border-box;
            "
          >
            <div style="text-align: right">
              <i
                class="el-icon-circle-close"
                style="font-size: 0.2rem"
                v-if="index != 0"
                @click="deleteLeaveType(index)"
              ></i>
            </div>
            <el-form-item>
              <div class="display:flex">
                <el-input
                  v-model="item.adderss"
                  placeholder="途径地"
                ></el-input>
              </div>
            </el-form-item>
            <el-form-item>
              <el-date-picker
                v-model="item.date"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-radio-group v-model="item.vehicles">
                <el-radio label="火车车次">火车车次</el-radio>
                <el-radio label="航班号">航班号</el-radio>
                <el-radio label="汽车班次及车牌">汽车班次及车牌</el-radio>
                <el-radio label="自驾车牌">自驾车牌</el-radio>
              </el-radio-group>
              <el-input v-model="item.vehiclesData" placeholder=""></el-input>
            </el-form-item>
          </div>
          <div
            style="display: flex; justify-content: flex-end; margin-top: 0.1rem"
          >
            <el-button type="primary" @click="myadd(1)">添加</el-button>
          </div>
        </el-form-item>
        <!-- <el-form-item label="6.车次、航班或车牌">
          <el-input v-model="ruleForm.car"></el-input>
        </el-form-item> -->
        <!-- <el-form-item label="7.14天内沿途是否经停高风险地区" prop="channelType">
          <el-radio-group v-model="ruleForm.channelType">
            <el-radio label="否">否</el-radio>
            <el-radio label="高风险地区">高风险地区</el-radio>
            <el-radio label="中风险地区">中风险地区</el-radio>
            <el-radio label="其他地区">其他地区</el-radio>
          </el-radio-group>
          <el-form-item
            label="途径地地址"
            v-if="ruleForm.channelType != '否'"
            prop="channelAddress"
          >
            <el-input v-model="ruleForm.channelAddress"></el-input>
          </el-form-item>
        </el-form-item> -->
        <el-form-item label="5.同行人员姓名和联系方式">
          <div
            v-for="(item, index) in ruleForm.peer"
            :key="index"
            style="
              border: 1px solid #ccc;
              margin-bottom: 0.1rem;
              padding: 0.1rem;
              box-sizing: border-box;
            "
          >
            <div style="text-align: right">
              <i
                class="el-icon-circle-close"
                style="font-size: 0.2rem"
                v-if="index != 0"
                @click="deletePeer(index)"
              ></i>
            </div>

            <el-form-item>
              <div class="display:flex">
                <el-input v-model="item.name" placeholder="姓名"></el-input>
              </div>
            </el-form-item>
            <el-form-item>
              <el-input v-model="item.idcard" placeholder="身份证号"></el-input>
            </el-form-item>
          </div>
          <div
            style="display: flex; justify-content: flex-end; margin-top: 0.1rem"
          >
            <el-button type="primary" @click="myadd(2)">添加</el-button>
          </div>
        </el-form-item>
        <el-form-item label="6.体温是否正常" prop="temperature">
          <el-radio-group v-model="ruleForm.temperature">
            <el-radio label="是">是</el-radio>
            <el-radio label="否">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- <el-form-item label="10.是否已做过核酸检测" prop="nuclein">
          <el-radio-group v-model="ruleForm.nuclein">
            <el-radio label="是">是</el-radio>
            <el-radio label="否">否</el-radio>
          </el-radio-group>
        </el-form-item> -->
        <el-form-item label="7.目前健康状态" prop="health">
          <el-radio-group v-model="ruleForm.health">
            <el-radio label="咳嗽"></el-radio>
            <el-radio label="咳痰"></el-radio>
            <el-radio label="流涕"></el-radio>
            <el-radio label="咽痛"></el-radio>
            <el-radio label="胸痛胸闷"></el-radio>
            <el-radio label="其他"></el-radio>
            <el-radio label="无上述异常症状">无上述异常症状</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div class="commitment">
        <el-checkbox v-model="commitment"></el-checkbox>
        <span>
          *本人承诺：
          <p style="line-height: 0.2rem; margin-top: 0.1rem">
            1、以上提供的信息资料均真实准确。如有不实，本人愿意承担由此引起的一切后果及法律责任。
          </p>
          <p style="line-height: 0.2rem; margin-top: 0.1rem">
            2、严格执行属地疫情防控措施，切实履行疫情防控个人责任，做好个人防护要求，配合宾馆执行人员管理措施。
          </p>
        </span>
      </div>
      <el-button
        v-if="ruleForm.id"
        type="primary"
        :disabled="!commitment"
        @click="changeForm('ruleForm')"
        style="width: 100%; margin-top: 0.3rem"
        >修改</el-button
      >
      <el-button
        v-else
        type="primary"
        :disabled="!commitment"
        @click="submitForm('ruleForm')"
        style="width: 100%; margin-top: 0.3rem"
        >提交</el-button
      >
    </div>
    <el-dialog
      :visible.sync="show"
      width="80%"
      :show-close="false"
      :close-on-click-modal="false"
      class="el-dialog-code"
    >
      <div class="pull">
        <div class="pull-title">温馨提示</div>
        <div class="pull-text">
          <p>您的门票信息已提交，</p>
          <p>请出示随申码入住。</p>
          <p>如需修改，请重新提交。</p>
        </div>
        <div class="pull-sumbit" @click="show = false">确定</div>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="goshow"
      width="80%"
      :show-close="false"
      :close-on-click-modal="false"
      class="el-dialog-code"
    >
      <div class="pull">
        <div class="pull-title">温馨提示</div>
        <div class="pull-text">
          <p>您的门票信息已提交，</p>
          <p>请出示随申码入住。</p>
          <p>如需修改，请重新提交。</p>
        </div>
        <div
          class="pull-sumbit"
          @click="
            show = goshow;
            $router.push('/entrance');
          "
        >
          确定
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      show: false,
      goshow: false,
      id: "",
      cardType: "身份证",
      ruleForm: {
        name: "",
        idcard: "",
        phone: "",
        // address: "",
        // leaveType: "否",
        trip: [
          {
            adderss: "",
            date: "",
            vehicles: "",
            vehiclesData: "",
          },
        ],
        leaveTime: null,
        // car: "",
        // channelType: "否",
        // channelAddress: "",
        peer: [
          {
            name: "",
            idcard: "",
          },
        ],
        temperature: "是",
        // nuclein: "是",
        health: "无上述异常症状",
      },
      rules: {
        name: [{ required: true, message: "请输入您的姓名", trigger: "blur" }],
        idcard: [
          { required: true, message: "请输入身份证/护照", trigger: "change" },
        ],
        phone: [
          { required: true, message: "请输入联系方式", trigger: "change" },
        ],
        address: [
          { required: true, message: "请输入在沪居住地址", trigger: "change" },
        ],
        trip: [
          {
            required: true,
            message: "请填写近三日内途径地",
            trigger: "change",
          },
        ],
        leaveType: [
          {
            required: true,
            message: "请填写近三日内途径地",
            trigger: "change",
          },
        ],
        leaveTime: [
          {
            required: true,
            message: "请选择离开日期",
            trigger: "change",
          },
        ],
        car: [
          {
            required: true,
            message: "请输入车次、航班或车牌",
            trigger: "change",
          },
        ],
        channelType: [
          {
            required: true,
            message: "请选择14天内沿途是否经停高风险地区",
            trigger: "change",
          },
        ],
        channelAddress: [
          {
            required: true,
            message: "请填写途径地地址",
            trigger: "change",
          },
        ],
        temperature: [
          { required: true, message: "请选择体温是否正常", trigger: "change" },
        ],
        nuclein: [
          {
            required: true,
            message: "请选择是否已做过核酸检测",
            trigger: "change",
          },
        ],
        health: [
          {
            required: true,
            message: "请选择目前健康状态",
            trigger: "change",
          },
        ],
      },
      commitment: false,
    };
  },
  components: {},
  created() {
    this.id = this.$route.params.id;
    this.myolad();
  },
  methods: {
    myolad() {
      this.$axios.get("/book/hotelDetail").then((res) => {
        if (res.data) {
          if (res.data.length != 0) {
            let mydata = res.data[0];
            mydata.peer = JSON.parse(mydata.peer);
            mydata.trip = JSON.parse(mydata.trip);
            this.ruleForm = mydata;
          }
          if (this.ruleForm.id) {
            this.show = true;
          }
        }
      });
    },
    //生成yyyy-mm-dd格式日期
    getDate(time) {
      let newtime = new Date(time);
      let my_y = newtime.getFullYear();
      let my_m =
        newtime.getMonth() + 1 > 9
          ? newtime.getMonth() + 1
          : "0" + (newtime.getMonth() + 1);
      let my_d =
        newtime.getDate() > 9 ? newtime.getDate() : "0" + newtime.getDate();
      let data;
      data = my_y + "-" + my_m + "-" + my_d;
      return data;
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.ruleForm.phone)) {
            this.$message.error("请录入正确的手机号码！");
            return false;
          }
          let data = { ...this.ruleForm };
          for (const element of data.trip) {
            for (const key in element) {
              if (!element[key]) {
                this.$message.error("请填写完整途径地内容");
                return false;
              }
            }
          }
          data.peer = JSON.stringify(data.peer);
          data.trip = JSON.stringify(data.trip);
          if (this.cardType == "身份证") {
            let regIdNo =
              /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
            if (!regIdNo.test(this.ruleForm.idcard)) {
              this.$message.error("身份证号码填写有误！");
              return false;
            }
            this.$axios
              .post("/book/identity", {
                idCard: this.ruleForm.idcard,
                name: this.ruleForm.name,
              })
              .then((res) => {
                this.commitment = false;
                if (res.code == 200) {
                  this.$axios.post("/book/hotel", data).then((res) => {
                    if (res.code == 200) {
                      this.goshow = true;
                    }
                  });
                } else {
                  this.$message.error(res.msg);
                }
              });
          } else {
            this.commitment = false;
            this.$axios.post("/book/hotel", data).then((res) => {
              if (res.code == 200) {
                this.goshow = true;
              }
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    changeForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.ruleForm.phone)) {
            this.$message.error("请录入正确的手机号码！");
            return false;
          }
          let data = { ...this.ruleForm };
          for (const element of data.trip) {
            for (const key in element) {
              if (!element[key]) {
                this.$message.error("请填写完整途径地内容");
                return false;
              }
            }
          }
          data.peer = JSON.stringify(data.peer);
          data.trip = JSON.stringify(data.trip);
          if (this.cardType == "身份证") {
            let regIdNo =
              /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
            if (!regIdNo.test(this.ruleForm.idcard)) {
              this.$message.error("身份证号码填写有误！");
              return false;
            }
            this.$axios
              .post("/book/identity", {
                idCard: this.ruleForm.idcard,
                name: this.ruleForm.name,
              })
              .then((res) => {
                this.commitment = false;
                if (res.code == 200) {
                  this.$axios.post("/book/hotelUpdate", data).then((res) => {
                    if (res.code == 200) {
                      this.goshow = true;
                    }
                  });
                } else {
                  this.$message.error(res.msg);
                }
              });
          } else {
            this.$axios.post("/book/hotelUpdate", data).then((res) => {
              this.commitment = false;
              if (res.code == 200) {
                this.$router.push("/entrance");
              }
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    myadd(index) {
      if (index == 1) {
        this.ruleForm.trip.push({
          name: "",
          idcard: "",
        });
      }

      if (index == 2) {
        this.ruleForm.peer.push({
          name: "",
          idcard: "",
        });
      }
    },
    //删除门票时间段
    deletePeer(index) {
      this.$delete(this.ruleForm.peer, index);
    },
    deleteLeaveType(index) {
      this.$delete(this.ruleForm.trip, index);
    },
  },
};
</script>
<style>
.el-dialog-code {
  display: flex;
  align-items: center;
  justify-content: center;
}
.el-dialog {
  margin: 0 0 !important;
  display: flex;
  flex-direction: column;
  border-radius: 0.05rem;
}
.el-dialog-code .el-dialog__body {
  padding: 0 0;
}
.el-dialog__header {
  display: none;
}
.cardType {
  display: flex;
}
.el-radio,
.el-radio__inner,
.el-radio__input {
  display: flex;
  line-height: 0.3rem;
  align-items: center;
}
.el-form-item {
  margin-bottom: 0.1rem !important;
}
.el-form-item__label {
  line-height: 0.35rem !important;
  padding-bottom: 0 !important;
  color: #000 !important;
  font-size: 0.16rem !important;
}
.big-title {
  font-size: 0.22rem;
  font-weight: 550;
}
</style>
<style scoped lang="less">
.appointment {
  min-height: 100%;
  position: relative;
  .avt {
    background-color: #2c7272;
    width: 100%;
    color: #fff;
    padding: 0.2rem 0.2rem 0.4rem 0.2rem;
    box-sizing: border-box;
    // height: 1.4rem;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .avt-image {
      box-sizing: border-box;
      width: 0.7rem;
      height: 0.7rem;
      border-radius: 50%;
      background-color: #fff;
    }
    .avt-text {
      width: 75%;
    }
  }
  .appointment-content {
    background-color: #fff;
    border-top-left-radius: 0.15rem;
    border-top-right-radius: 0.15rem;
    position: relative;
    top: -0.2rem;
    padding: 0 0.2rem;
    box-sizing: border-box;
    padding-top: 0.3rem;
    .commitment {
      color: red;
      font-size: 0.14rem;
      margin-top: 0.2rem;
    }
  }
}
.pull {
  text-align: center;
  .pull-title {
    color: #000;
    font-weight: 600;
    font-size: 0.18rem;
    padding-top: 0.3rem;
  }
  .pull-text {
    font-size: 0.16rem;
    line-height: 0.27rem;
    padding: 0.3rem 0.2rem;
  }
  .pull-sumbit {
    font-weight: 600;
    font-size: 0.16rem;
    color: #409eff;
    border-top: 1px solid #ccc;
    line-height: 0.45rem;
  }
}
</style>